import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visie',
  templateUrl: './visie.component.html',
  styleUrls: ['./visie.component.sass']
})
export class VisieComponent implements OnInit {

  topic:string = "";

  constructor() { }

  ngOnInit(): void {
  }

  selectTopic(topic:string) {
    this.topic = topic;
  }
}
